module.exports = __webpack_public_path__ + "media/addons/ArtReturn-1b2e5bf0.svg";